import {
  ModalsStyled,
  ModalsConfirmeStyled,
  ModalsEstacaoStyled,
  ModalsPocoStyled,
  ModalsBombaStyled,
  ModalUpdateEstacaoStyled,
} from "../../Styles/Modals";
import { AiOutlineUserAdd } from "react-icons/ai";
import {
  MdOutlineDriveFileRenameOutline,
  MdOutlineAppRegistration,
  MdOutlineEmail,
} from "react-icons/md";
import { RiLockPasswordLine } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import { useContext, useEffect, useState } from "react";
import { AdminContext } from "../../Context/ContextAdmin";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { apiSae } from "../../services/api";
import { HomeContext } from "../../Context/ContextHome";
import { TbArrowBackUp } from "react-icons/tb";
import helicoidal from "../../Assets/Icons/helicoidal.svg";
import vertical from "../../Assets/Icons/deslocamentoVertical.svg";
import { toast, Zoom } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  ComponentUpdateBombasPoco1,
  ComponentUpdateBombasPoco2,
  ComponentUpdateEstacao,
  ComponentUpdatePoco1,
  ComponentUpdatePoco2,
  ComponenteOpcaoPocos,
  ConfirmaUpdate,
} from "../../components/updateEstacao";

export const ModalsCreateUser = () => {
  const { modalCreateUser, setModalCreateUser, aoCriarUsuario } =
    useContext(AdminContext);

  const [mostrarSenha, setMostrarSenha] = useState(false);

  const FormSchema = yup.object().shape({
    usuario: yup.string().required("*Este campo é obrigatório"),
    nome: yup.string().required("*Este campo é obrigatório"),

    email: yup
      .string()
      .email("*E-mail inválido")
      .required("*Este campo é obrigatório"),

    matricula: yup.string().required("*Este campo é obrigatório"),

    password: yup
      .string()
      .min(8, "*Deve conter no  8 caracteres")
      .matches(
        /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+])[a-zA-Z0-9!@#$%^&*()_+]+$/,
        "Mín. 1 Letra Maiúscula e 1 Carac. especial"
      )
      .required("*Este campo é obrigatório"),

    confirmaSenha: yup
      .string()
      .oneOf([yup.ref("password"), null], "As senhas devem ser iguais")
      .required("Este campo é obrigatório"),

    role: yup.string().required("Este campo é obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(FormSchema),
  });

  return (
    <ModalsStyled>
      <form className="blocoUsuario" onSubmit={handleSubmit(aoCriarUsuario)}>
        <h3>Cadastro de Usuários</h3>
        <span
          className="fechaModal"
          onClick={() => setModalCreateUser(!modalCreateUser)}
        >
          <IoClose />
        </span>
        <div className="inpults">
          <label>Usuário:</label>
          <span>
            <AiOutlineUserAdd />
          </span>
          <input
            placeholder="Digite o Usúario"
            type="text"
            {...register("usuario")}
          />
          {errors.usuario && <p>{errors.usuario.message}</p>}
        </div>
        <div className="inpults">
          <label>Nome Completo:</label>
          <span>
            <MdOutlineDriveFileRenameOutline />
          </span>
          <input
            placeholder="Digite o Nome Completo"
            type="text"
            {...register("nome")}
          />
          {errors.nome && <p>{errors.nome.message}</p>}
        </div>
        <div className="inpults">
          <label>Email:</label>
          <span>
            <MdOutlineEmail />
          </span>
          <input
            placeholder="Digite o email"
            type="email"
            {...register("email")}
          />
          {errors.email && <p>{errors.email.message}</p>}
        </div>
        <div className="inpults">
          <label>Matricula:</label>
          <span>
            <MdOutlineAppRegistration />
          </span>
          <input
            placeholder="Digite a matricula"
            type="text"
            {...register("matricula")}
          />
          {errors.matricula && <p>{errors.matricula.message}</p>}
        </div>
        <div className="divSenha inpults">
          <div className="campoSenha">
            <label>Senha:</label>
            <span>
              <RiLockPasswordLine />
            </span>
            <div className="inputSenha">
              <input
                placeholder="Digite a Senha"
                type={mostrarSenha ? "text" : "password"}
                {...register("password")}
              />
              <button
                type="button"
                className="toggleSenha"
                onClick={() => setMostrarSenha(!mostrarSenha)}
              >
                {mostrarSenha ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>

            {errors.password && <p>{errors.password.message}</p>}
          </div>
          <div className="campoSenha">
            <label>Confirmar Senha:</label>
            <span>
              <RiLockPasswordLine />
            </span>
            <div className="inputSenha">
              <input
                placeholder="Confirme a Senha"
                type={mostrarSenha ? "text" : "password"}
                {...register("confirmaSenha")}
              />
              <button
                type="button"
                className="toggleSenha"
                onClick={() => setMostrarSenha(!mostrarSenha)}
              >
                {mostrarSenha ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
            {errors.confirmaSenha && <p>{errors.confirmaSenha.message}</p>}
          </div>
        </div>
        <div className="tituloRadiobox">
          <h3>Nível de Acesso</h3>
        </div>
        <div className="checkboxUsuarios">
          <div>
            <input
              type="radio"
              id="nivel1"
              name="nivel"
              value={"1"}
              {...register("role")}
            />
            {errors.role && <p>{errors.role.message}</p>}
            <label htmlFor="nivel1">Nível I</label>
          </div>
          <div>
            <input
              type="radio"
              id="nivel2"
              name="nivel"
              value={"2"}
              {...register("role")}
            />
            <label htmlFor="nivel2">Nível II</label>
          </div>
          <div>
            <input
              type="radio"
              id="nivel3"
              name="nivel"
              value={"3"}
              {...register("role")}
            />
            <label htmlFor="nivel3">Nível III</label>
          </div>
        </div>
        <div>
          <p>
            Nível I: Acesso apenas para visualização do sistema. Nível II:
            Acesso para visualização e controle do sistema. Nível III: Acesso
            com permissões de administrador.
          </p>
        </div>
        <div className="botao">
          <button type="submit">Salvar</button>
        </div>
      </form>
    </ModalsStyled>
  );
};

export const ModalsUpdateUser = () => {
  const {
    modalUpdateUser,
    setModalUpdateUser,
    aoEditarUsuario,
    selecionaUsuario,
    users,
  } = useContext(AdminContext);

  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [mostrarConfirmaSenha, setMostrarConfirmaSenha] = useState(false);

  const infoUsuarios = users.find((e) => e.id === selecionaUsuario[0]);

  const FormSchema = yup.object().shape({
    usuario: yup.string().required("*Este campo é obrigatório"),
    nome: yup.string().required("*Este campo é obrigatório"),

    email: yup
      .string()
      .email("*E-mail inválido")
      .required("*Este campo é obrigatório"),

    matricula: yup.string().required("*Este campo é obrigatório"),

    password: yup.string().test({
      name: "requiredIfFilled",
      test: function (value) {
        if (!value || value.length === 0) {
          return true;
        } else {
          return (
            value.length >= 8 &&
            /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+])[a-zA-Z0-9!@#$%^&*()_+]+$/.test(
              value
            )
          );
        }
      },
      message: "Mín. 8 Carac. sendo 1 Letra Maiúscula e 1 Carac. especial",
    }),

    confirmaSenha: yup
      .string()
      .oneOf([yup.ref("password"), null], "As senhas devem ser iguais"),

    role: yup.string().required("Este campo é obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(FormSchema),
  });

  return (
    <ModalsStyled>
      <form className="blocoUsuario" onSubmit={handleSubmit(aoEditarUsuario)}>
        <h3>Cadastro de Usuários</h3>
        <span
          className="fechaModal"
          onClick={() => setModalUpdateUser(!modalUpdateUser)}
        >
          <IoClose />
        </span>
        <div className="inpults">
          <label>Usuário:</label>
          <span>
            <AiOutlineUserAdd />
          </span>
          <input
            placeholder="Digite o Usúario"
            type="text"
            defaultValue={infoUsuarios.usuario}
            {...register("usuario")}
          />
          {errors.usuario && <p>{errors.usuario.message}</p>}
        </div>
        <div className="inpults">
          <label>Nome Completo:</label>
          <span>
            <MdOutlineDriveFileRenameOutline />
          </span>
          <input
            placeholder="Digite o Nome Completo"
            type="text"
            defaultValue={infoUsuarios.nome}
            {...register("nome")}
          />
          {errors.nome && <p>{errors.nome.message}</p>}
        </div>
        <div className="inpults">
          <label>Email:</label>
          <span>
            <MdOutlineEmail />
          </span>
          <input
            placeholder="Digite o email"
            type="email"
            defaultValue={infoUsuarios.email}
            {...register("email")}
          />
          {errors.email && <p>{errors.email.message}</p>}
        </div>
        <div className="inpults">
          <label>Matricula:</label>
          <span>
            <MdOutlineAppRegistration />
          </span>
          <input
            placeholder="Digite a matricula"
            type="text"
            defaultValue={infoUsuarios.matricula}
            {...register("matricula")}
            // disabled={isRestrictedUser}
          />
          {errors.matricula && <p>{errors.matricula.message}</p>}
        </div>

        <div className="divSenha inpults">
          <div className="campoSenha">
            <label>Senha:</label>
            <span>
              <RiLockPasswordLine />
            </span>
            <div className="inputSenha">
              <input
                placeholder="Digite a Senha"
                type={mostrarSenha ? "text" : "password"}
                {...register("password")}
              />
              <button
                type="button"
                className="toggleSenha"
                onClick={() => setMostrarSenha(!mostrarSenha)}
              >
                {mostrarSenha ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
            {errors.hash_senha && <p>{errors.hash_senha.message}</p>}
          </div>
          <div className="campoSenha">
            <label>Confirmar Senha:</label>
            <span>
              <RiLockPasswordLine />
            </span>

            <div className="inputSenha">
              <input
                placeholder="Confirme a Senha"
                type={mostrarSenha ? "text" : "password"}
                {...register("confirmaSenha")}
              />
              <button
                type="button"
                className="toggleSenha"
                onClick={() => setMostrarSenha(!mostrarSenha)}
              >
                {mostrarSenha ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
            {errors.confirmaSenha && <p>{errors.confirmaSenha.message}</p>}
          </div>
        </div>

        <div className="tituloRadiobox">
          <h3>Nível de Acesso</h3>
        </div>
        <div className="checkboxUsuarios">
          <div>
            <input
              type="radio"
              id="nivel1"
              name="nivel"
              value={"1"}
              defaultChecked={infoUsuarios.role === "1"}
              {...register("role")}
            />
            {errors.role && <p>{errors.role.message}</p>}
            <label htmlFor="nivel1">Nível I</label>
          </div>
          <div>
            <input
              type="radio"
              id="nivel2"
              name="nivel"
              value={"2"}
              defaultChecked={infoUsuarios.role === "2"}
              {...register("role")}
            />
            <label htmlFor="nivel2">Nível II</label>
          </div>
          <div>
            <input
              type="radio"
              id="nivel3"
              name="nivel"
              value={"3"}
              defaultChecked={infoUsuarios.role === "3"}
              {...register("role")}
            />
            <label htmlFor="nivel3">Nível III</label>
          </div>
          {/* Renderizar o nível 4 só se role for 4 */}
          {infoUsuarios.role === "4" && (
            <div>
              <input
                type="radio"
                id="nivel4"
                name="nivel"
                value={"4"}
                defaultChecked={true} // porque o usuário já é role 4
                {...register("role")}
              />
              <label htmlFor="nivel4">Nível IV</label>
            </div>
          )}
        </div>
        <div>
          <p>
            Nível I: Acesso apenas para visualização do sistema. Nível II:
            Acesso para visualização e controle do sistema. Nível III: Acesso
            com permissões de administrador. Nível IV: Acesso com permissões de
            desenvolvedor.
          </p>
        </div>

        <div className="botao">
          <button type="submit">Salvar</button>
        </div>
      </form>
    </ModalsStyled>
  );
};

export const ModalsDesableUser = () => {
  const {
    modalDesableUser,
    setDesableUser,
    selecionaUsuario,
    aoDesabilitaUsuario,
  } = useContext(AdminContext);

  return (
    <ModalsConfirmeStyled>
      <div className="blocoConfirma">
        <h3>Tem certeza que deseja executar esta ação?</h3>
        <div className="botao">
          <button onClick={() => aoDesabilitaUsuario()}>Sim</button>
          <button
            className="botaoNao"
            onClick={() => setDesableUser(!modalDesableUser)}
          >
            Não
          </button>
        </div>
      </div>
    </ModalsConfirmeStyled>
  );
};

export const ModalsCreateEstacao = () => {
  const {
    modalCreateEstacao,
    setModalCreateEstacao,
    setModalCreatePoco,
    setCreateEstacao,
    createEstacao,
  } = useContext(AdminContext);

  const { headerApi } = useContext(HomeContext);

  const [cidades, setCidades] = useState([]);

  const cidadesLista = async () => {
    try {
      const response = await apiSae.get("cidades/LeituraTodos", headerApi);
      setCidades(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const FormSchema = yup.object().shape({
    cidade: yup
      .number()
      .typeError("*Confirme a Cidade")
      .required("*Este campo é obrigatório")
      .min(1, "*Selecione uma cidade válida"),

    nome_estacao: yup.string().required("*Este campo é obrigatório"),

    tipo: yup.string().required("*Este campo é obrigatório"),
    codigo: yup.string().required("*Este campo é obrigatório"),
    possui_gerador: yup.boolean().required("*Este campo é obrigatório"),
    ativo: yup.boolean().required("*Este campo é obrigatório"),

    quantidadePocos: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .required("*Este campo é obrigatório")
      .typeError("*Este campo é obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(FormSchema),
  });

  useEffect(() => {
    cidadesLista();
  }, []);

  const ArmazenaDados = (data) => {
    setCreateEstacao([data]);
    setModalCreateEstacao(false);
    setModalCreatePoco(true);
  };

  return (
    <ModalsEstacaoStyled>
      <form className="blocoEstacao" onSubmit={handleSubmit(ArmazenaDados)}>
        <div className="titulo">
          <h3>Cadastrar Estação</h3>
          <span
            className="fechaModal"
            onClick={() => {
              setModalCreateEstacao(!modalCreateEstacao);
              setCreateEstacao([]);
            }}
          >
            <IoClose />
          </span>
        </div>

        <div className="estacao">
          <div className="cadEstacao">
            <div className="divSeletores">
              <div className="seletores">
                <label>Cidade:</label>

                <select
                  {...register("cidade")}
                  defaultValue={createEstacao[0]?.cidade ?? ""}
                >
                  <option value="" disabled hidden>
                    Selecione Cidade
                  </option>{" "}
                  {/* Opção padrão visível */}
                  {cidades.map((cidade) => (
                    <option value={cidade.id} key={cidade.id}>
                      {cidade.nome_cidade}
                    </option>
                  ))}
                </select>
                {errors.cidade && <p>{errors.cidade.message}</p>}
              </div>

              <div className="seletores">
                <label>Tipo de Estação:</label>
                <select
                  {...register("tipo")}
                  defaultValue={createEstacao[0]?.tipo ?? ""}
                >
                  <option value="" selected disabled hidden>
                    Selecione Modelo Bomba
                  </option>
                  <option value={"Elevatória"}>Elevatória</option>
                </select>
                {errors.tipo && <p>{errors.tipo.message}</p>}
              </div>

              <div className="seletores">
                <label>Qtd. de Poços:</label>
                <select
                  {...register("quantidadePocos")}
                  defaultValue={createEstacao[0]?.quantidadePocos ?? ""}
                >
                  <option value="" selected disabled hidden>
                    Seleciona Qtd Poços
                  </option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                </select>
                {errors.quantidadePocos && (
                  <p>{errors.quantidadePocos.message}</p>
                )}
              </div>
            </div>
            <div className="divInputs">
              <div className="inputs">
                <label>Nome da Estação:</label>
                <input
                  defaultValue={createEstacao[0]?.nome_estacao ?? ""}
                  placeholder="Digite o nome da Estação"
                  type="text"
                  {...register("nome_estacao")}
                ></input>
                {errors.nome_estacao && <p>{errors.nome_estacao.message}</p>}
              </div>
              <div className="inputs">
                <label>Codigo da Estação:</label>
                <input
                  defaultValue={createEstacao[0]?.codigo ?? ""}
                  placeholder="Digite o Codigo Sigla da Estação"
                  type="text"
                  {...register("codigo")}
                ></input>
                {errors.codigo && <p>{errors.codigo.message}</p>}
              </div>
              <div className="divCheck">
                <div className="check">
                  <input
                    defaultChecked={createEstacao[0]?.possui_gerador ?? ""}
                    type="checkbox"
                    {...register("possui_gerador", {
                      valueAsNumber: true,
                      setValueAs: (value) => value || false,
                    })}
                  ></input>
                  <label>Possui Gerador</label>
                </div>
                <div className="check">
                  <input
                    defaultChecked={createEstacao[0]?.ativo ?? ""}
                    type="checkbox"
                    {...register("ativo", {
                      valueAsNumber: true,
                      setValueAs: (value) => value || false,
                    })}
                  ></input>
                  <label>Unidade Ativa</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="botaoContinuar">
          <div className="botao">
            <button type="submit">Continuar</button>
          </div>
        </div>
      </form>
    </ModalsEstacaoStyled>
  );
};

export const ModalsCreatePoco = () => {
  const {
    modalCreatePoco,
    setModalCreatePoco,
    setModalCreateEstacao,
    setModalCreateBomba,
    createEstacao,
    setCreateEstacao,
  } = useContext(AdminContext);

  const { headerApi } = useContext(HomeContext);

  const FormSchema = yup.object().shape({
    altura_poco: yup
      .number()
      .nullable("*Este campo é obrigatório")
      .typeError("*Este campo deve ser um númeroP1")
      .required("*Este campo é obrigatório"),
    altura_util_poco: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_minimo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_maximo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    quantidade_bombas: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    cesta: yup.boolean().required("*Este campo é obrigatório"),
  });

  const FormSchema2 = yup.object().shape({
    altura_poco: yup
      .number()
      .nullable("*Este campo é obrigatórioPP1")
      .typeError("*Este campo deve ser um númeroPP1")
      .required("*Este campo é obrigatórioPP1"),
    altura_util_poco: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_minimo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_maximo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    quantidade_bombas: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    cesta: yup.boolean().required("*Este campo é obrigatório"),

    altura_poco2: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um númeroPP2")
      .required("*Este campo é obrigatórioPP2"),
    altura_util_poco2: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_minimo2: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_maximo2: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    quantidade_bombas2: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    cesta2: yup.boolean().required("*Este campo é obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(
      createEstacao[0].quantidadePocos === 2 ? FormSchema2 : FormSchema
    ),
  });

  const ArmazenaDadosPoco = async (data) => {
    let novoDadosEstacao = [createEstacao[0]];

    novoDadosEstacao.push(data);
    setCreateEstacao(novoDadosEstacao);

    setModalCreatePoco(!modalCreatePoco);
    setModalCreateBomba(true);
  };

  return (
    <ModalsPocoStyled>
      <div className="blocoPoco">
        <form onSubmit={handleSubmit(ArmazenaDadosPoco)}>
          <div className="divPocos">
            <div className="divPoco1">
              <h3>Cadastrar Poço 1</h3>
              <span
                className="fechaModal"
                onClick={() => {
                  setModalCreatePoco(!modalCreatePoco);
                  setModalCreateEstacao(true);
                }}
              >
                <TbArrowBackUp />
              </span>
              <div className="cadPoco">
                <div className="divSeletores">
                  <div className="seletores">
                    <label>Altura do Poço:</label>
                    <input
                      defaultValue={createEstacao[1]?.altura_poco ?? ""}
                      placeholder="Altura do Poço"
                      type="number"
                      step="any"
                      {...register("altura_poco")}
                    ></input>
                    {errors.altura_poco && <p>{errors.altura_poco.message}</p>}
                  </div>
                  <div className="seletores">
                    <label>Nível Mínimo do Poço:</label>
                    <input
                      defaultValue={createEstacao[1]?.nivel_minimo ?? ""}
                      placeholder="Nível Mínimo"
                      type="number"
                      step="any"
                      {...register("nivel_minimo")}
                    ></input>
                    {errors.nivel_minimo && (
                      <p>{errors.nivel_minimo.message}</p>
                    )}
                  </div>
                  <div className="seletores">
                    <label>Altura Útil do Poço:</label>
                    <input
                      defaultValue={createEstacao[1]?.altura_util_poco ?? ""}
                      placeholder="Altura Útil"
                      type="number"
                      step="any"
                      {...register("altura_util_poco")}
                    ></input>
                    {errors.altura_util_poco && (
                      <p>{errors.altura_util_poco.message}</p>
                    )}
                  </div>
                </div>
                <div className="divSeletores">
                  <div className="seletores">
                    <label>Nível Máximo do Poço:</label>
                    <input
                      defaultValue={createEstacao[1]?.nivel_maximo ?? ""}
                      placeholder="Nível Máximo"
                      type="number"
                      step="any"
                      {...register("nivel_maximo")}
                    ></input>
                    {errors.nivel_maximo && (
                      <p>{errors.nivel_maximo.message}</p>
                    )}
                  </div>
                  <div className="seletores">
                    <label>Qtd de Bombas:</label>
                    <select
                      {...register("quantidade_bombas")}
                      defaultValue={createEstacao[1]?.quantidade_bombas ?? ""}
                    >
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                    </select>
                  </div>
                  <div className="check">
                    <input
                      defaultChecked={createEstacao[1]?.cesta ?? ""}
                      type="checkbox"
                      {...register("cesta", {
                        valueAsNumber: true,
                        setValueAs: (value) => value || false,
                      })}
                    ></input>
                    <label>Possui Cesta</label>
                  </div>
                </div>
              </div>
            </div>

            {createEstacao[0].quantidadePocos === 2 && (
              <div className="divPoco2">
                <h3 className="tituloP2">Cadastrar Poço 2</h3>
                <div className="cadPoco">
                  <div className="divSeletores">
                    <div className="seletores">
                      <label>Altura do Poço:</label>
                      <input
                        defaultValue={createEstacao[1]?.altura_poco2 ?? ""}
                        placeholder="Digite a Altura do Poço"
                        type="number"
                        step="any"
                        {...register("altura_poco2")}
                      ></input>
                      {errors.altura_poco2 && (
                        <p>{errors.altura_poco2.message}</p>
                      )}
                    </div>
                    <div className="seletores">
                      <label>Nível Mínimo do Poço:</label>
                      <input
                        placeholder="Nível Minimo"
                        type="number"
                        step="any"
                        {...register("nivel_minimo2")}
                      ></input>
                      {errors.nivel_minimo2 && (
                        <p>{errors.nivel_minimo2.message}</p>
                      )}
                    </div>

                    <div className="seletores">
                      <label>Altura Útil do Poço:</label>
                      <input
                        placeholder="Altura Útil"
                        type="number"
                        step="any"
                        {...register("altura_util_poco2")}
                      ></input>
                      {errors.altura_util_poco2 && (
                        <p>{errors.altura_util_poco2.message}</p>
                      )}
                    </div>
                  </div>
                  <div className="divSeletores">
                    <div className="seletores">
                      <label>Nível Máximo do Poço:</label>
                      <input
                        placeholder="Nível Máximo"
                        type="number"
                        step="any"
                        {...register("nivel_maximo2")}
                      ></input>
                      {errors.nivel_maximo2 && (
                        <p>{errors.nivel_maximo2.message}</p>
                      )}
                    </div>
                    <div className="seletores">
                      <label>Qtd de Bombas:</label>
                      <select {...register("quantidade_bombas2")}>
                        <option value={1}>1</option>
                        <option value={2}>2</option>
                        <option value={3}>3</option>
                      </select>
                    </div>
                    <div className="check">
                      <input
                        type="checkbox"
                        {...register("cesta2", {
                          valueAsNumber: true,
                          setValueAs: (value) => value || false,
                        })}
                      ></input>
                      <label>Possui Cesta</label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="botaoContinuar">
            <button type="submit">Continuar</button>
          </div>
        </form>
      </div>
    </ModalsPocoStyled>
  );
};

export const ModalsCreateBomba = () => {
  const {
    modalCreateBomba,
    setModalCreateBomba,
    setModalCreatePoco,
    setCreateEstacao,
    createEstacao,
    modalCreateBombaPoco2,
    setModalCreateBombaPoco2,
    aoSalvarDados,
  } = useContext(AdminContext);

  const [imgBomba, setImgBomba] = useState(null);
  const [imgBomba2, setImgBomba2] = useState(null);
  const [imgBomba3, setImgBomba3] = useState(null);

  const handleSelectChange = (event, bomba) => {
    const selectedOption = event.target.value;

    if (bomba === 1) {
      if (selectedOption === "helicoidal") {
        setImgBomba(helicoidal);
      } else if (selectedOption === "vertical") {
        setImgBomba(vertical);
      }
    }
    if (bomba === 2) {
      if (selectedOption === "helicoidal") {
        setImgBomba2(helicoidal);
      } else if (selectedOption === "vertical") {
        setImgBomba2(vertical);
      }
    }
    if (bomba === 3) {
      if (selectedOption === "helicoidal") {
        setImgBomba3(helicoidal);
      } else if (selectedOption === "vertical") {
        setImgBomba3(vertical);
      }
    }
  };

  const FormSchema = yup.object().shape({
    tipo_bomba: yup.string().required("*Este campo é obrigatório"),
    nivel_acionamento: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    nivel_desligamento: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
  });

  const FormSchema2 = yup.object().shape({
    tipo_bomba: yup.string().required("*Este campo é obrigatório"),
    nivel_acionamento: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    nivel_desligamento: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    tipo_bomba2: yup.string().required("*Este campo é obrigatório"),
    nivel_acionamento2: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    nivel_desligamento2: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
  });

  const FormSchema3 = yup.object().shape({
    tipo_bomba: yup.string().required("*Este campo é obrigatório"),
    nivel_acionamento: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    nivel_desligamento: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    tipo_bomba2: yup.string().required("*Este campo é obrigatório"),
    nivel_acionamento2: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    nivel_desligamento2: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    tipo_bomba3: yup.string().required("*Este campo é obrigatório"),
    nivel_acionamento3: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    nivel_desligamento3: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(
      createEstacao[1].quantidade_bombas === 1
        ? FormSchema
        : createEstacao[1].quantidade_bombas === 2
        ? FormSchema2
        : FormSchema3
    ),
  });

  const ArmazenaDadosBomba = async (data) => {
    if (createEstacao[0].quantidadePocos === 1) {
      let novoDadosEstacao = createEstacao;
      novoDadosEstacao.push(data);
      setCreateEstacao(novoDadosEstacao);

      setModalCreateBomba(!modalCreateBomba);
      aoSalvarDados();
    } else {
      let novoDadosEstacao = createEstacao;
      novoDadosEstacao.push(data);
      setCreateEstacao(novoDadosEstacao);
      setModalCreateBomba(!modalCreateBomba);
      setModalCreateBombaPoco2(true);
    }
  };

  return (
    <ModalsBombaStyled>
      <form className="blocoBomba" onSubmit={handleSubmit(ArmazenaDadosBomba)}>
        <h3>Poço 1</h3>
        <span
          className="fechaModal"
          onClick={() => {
            setModalCreateBomba(!modalCreateBomba);
            setModalCreatePoco(true);
          }}
        >
          <TbArrowBackUp />
        </span>

        <div className="divBomba1">
          <h3 className="tituloBombas">Cadastrar Bomba 1</h3>
          <div className="cadPoco">
            <div className="divSeletores">
              <div className="seletores">
                <label>Modelo de Bomba:</label>
                <select
                  {...register("tipo_bomba")}
                  onChange={(event) => handleSelectChange(event, 1)}
                >
                  <option value="" selected disabled hidden>
                    Seleciona um modelo
                  </option>
                  <option value={"helicoidal"}>Helicoidal</option>
                  <option value={"vertical"}>Deslocamento Vertival</option>
                </select>
                {errors.tipo_bomba && <p>{errors.tipo_bomba.message}</p>}
              </div>
              <div className="seletores">
                <label>Nível de Acionamento:</label>
                <input
                  placeholder="Nível de Acionamento"
                  type="number"
                  step="any"
                  {...register("nivel_acionamento")}
                ></input>
                {errors.nivel_acionamento && (
                  <p>{errors.nivel_acionamento.message}</p>
                )}
              </div>
              <div className="seletores">
                <label>Nível de Desligamento:</label>
                <input
                  placeholder="Nível de Desligamento"
                  type="number"
                  step="any"
                  {...register("nivel_desligamento")}
                ></input>
                {errors.nivel_desligamento && (
                  <p>{errors.nivel_desligamento.message}</p>
                )}
              </div>
            </div>
            <div className="divSeletores">
              <div className="imgBomba">
                <img src={imgBomba} alt="" />
              </div>
            </div>
          </div>
        </div>

        {createEstacao[1].quantidade_bombas >= 2 && (
          <div className="divBomba2">
            <h3>Cadastrar Bomba 2</h3>
            <div className="cadPoco">
              <div className="divSeletores">
                <div className="seletores">
                  <label>Modelo de Bomba:</label>
                  <select
                    {...register("tipo_bomba2")}
                    onChange={(event) => handleSelectChange(event, 2)}
                  >
                    <option value="" selected disabled hidden>
                      Seleciona um modelo
                    </option>
                    <option value={"helicoidal"}>Helicoidal</option>
                    <option value={"vertical"}>Deslocamento Vertival</option>
                  </select>
                  {errors.tipo_bomba2 && <p>{errors.tipo_bomba2.message}</p>}
                </div>
                <div className="seletores">
                  <label>Nível de Acionamento:</label>
                  <input
                    placeholder="Nível de Acionamento"
                    type="number"
                    step="any"
                    {...register("nivel_acionamento2")}
                  ></input>
                  {errors.nivel_acionamento2 && (
                    <p>{errors.nivel_acionamento2.message}</p>
                  )}
                </div>
                <div className="seletores">
                  <label>Nível de Desligamento:</label>
                  <input
                    placeholder="Nível de Desligamento"
                    type="number"
                    step="any"
                    {...register("nivel_desligamento2")}
                  ></input>
                  {errors.nivel_desligamento2 && (
                    <p>{errors.nivel_desligamento2.message}</p>
                  )}
                </div>
              </div>
              <div className="divSeletores">
                <div className="imgBomba">
                  <img src={imgBomba2} alt="" />
                </div>
              </div>
            </div>
          </div>
        )}

        {createEstacao[1].quantidade_bombas === 3 && (
          <div className="divBomba3">
            <h3>Cadastrar Bomba 3</h3>
            <div className="cadPoco">
              <div className="divSeletores">
                <div className="seletores">
                  <label>Modelo de Bomba:</label>
                  <select
                    {...register("tipo_bomba3")}
                    onChange={(event) => handleSelectChange(event, 3)}
                  >
                    <option value="" selected disabled hidden>
                      Seleciona um modelo
                    </option>
                    <option value={"helicoidal"}>Helicoidal</option>
                    <option value={"vertical"}>Deslocamento Vertival</option>
                  </select>
                  {errors.tipo_bomba3 && <p>{errors.tipo_bomba3.message}</p>}
                </div>
                <div className="seletores">
                  <label>Nível de Acionamento:</label>
                  <input
                    placeholder="Nível de Acionamento"
                    type="number"
                    step="any"
                    {...register("nivel_acionamento3")}
                  ></input>
                  {errors.nivel_acionamento3 && (
                    <p>{errors.nivel_acionamento3.message}</p>
                  )}
                </div>
                <div className="seletores">
                  <label>Nível de Desligamento:</label>
                  <input
                    placeholder="Nível de Desligamento"
                    type="number"
                    step="any"
                    {...register("nivel_desligamento3")}
                  ></input>
                  {errors.nivel_desligamento3 && (
                    <p>{errors.nivel_desligamento3.message}</p>
                  )}
                </div>
              </div>
              <div className="divSeletores">
                <div className="imgBomba">
                  <img src={imgBomba3} alt="" />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="botaoContinuar">
          <button type="submit">Continuar</button>
        </div>
      </form>
    </ModalsBombaStyled>
  );
};

export const ModalsCreateBombaPoco2 = () => {
  const {
    modalCreateBombaPoco2,
    setModalCreateBombaPoco2,
    setModalCreatePoco,
    setCreateEstacao,
    createEstacao,
    aoSalvarDados,
  } = useContext(AdminContext);

  const [imgBomba, setImgBomba] = useState(null);
  const [imgBomba2, setImgBomba2] = useState(null);
  const [imgBomba3, setImgBomba3] = useState(null);

  const handleSelectChange = (event, bomba) => {
    const selectedOption = event.target.value;
    if (bomba === 1) {
      if (selectedOption === "helicoidal") {
        setImgBomba(helicoidal);
      } else if (selectedOption === "vertical") {
        setImgBomba(vertical);
      }
    } else if (bomba === 2) {
      if (selectedOption.value === "helicoidal") {
        setImgBomba2(helicoidal);
      } else if (selectedOption === "vertical") {
        setImgBomba2(vertical);
      }
    } else if (bomba === 3) {
      if (selectedOption === "helicoidal") {
        setImgBomba3(helicoidal);
      } else if (selectedOption === "vertical") {
        setImgBomba3(vertical);
      }
    }
  };

  const FormSchema = yup.object().shape({
    tipo_bomba: yup.string().required("*Este campo é obrigatório"),
    nivel_acionamento: yup
      .number()
      .nullable("*Este campo é obrigatório")
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_desligamento: yup
      .number()
      .nullable("*Este campo é obrigatório")
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    tipo_bomba2: yup.string().when("createEstacao", {
      is: (val) => val && val[1] && val[1].quantidade_bombas >= 2,
      then: yup.string().required("*Este campo é obrigatório"),
    }),

    nivel_acionamento2: yup.number().when("createEstacao", {
      is: (val) => val && val[1] && val[1].quantidade_bombas >= 2,
      then: yup
        .number()
        .nullable("*Este campo é obrigatório")
        .typeError("*Este campo deve ser um número")
        .required("*Este campo é obrigatório"),
    }),

    nivel_desligamento2: yup.number().when("createEstacao", {
      is: (val) => val && val[1] && val[1].quantidade_bombas >= 2,
      then: yup
        .number()
        .nullable("*Este campo é obrigatório")
        .typeError("*Este campo deve ser um número")
        .required("*Este campo é obrigatório"),
    }),

    tipo_bomba3: yup.string().when("createEstacao", {
      is: (val) => val && val[1] && val[1].quantidade_bombas === 3,
      then: yup.string().required("*Este campo é obrigatório"),
    }),

    nivel_acionamento3: yup.number().when("createEstacao", {
      is: (val) => val && val[1] && val[1].quantidade_bombas === 3,
      then: yup
        .number()
        .nullable("*Este campo é obrigatório")
        .typeError("*Este campo deve ser um número")
        .required("*Este campo é obrigatório"),
    }),

    nivel_desligamento3: yup.number().when("createEstacao", {
      is: (val) => val && val[1] && val[1].quantidade_bombas === 3,
      then: yup
        .number()
        .nullable("*Este campo é obrigatório")
        .typeError("*Este campo deve ser um número")
        .required("*Este campo é obrigatório"),
    }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(FormSchema),
  });

  const ArmazenaDadosBombaPoco2 = async (data) => {
    let novoDadosEstacao = createEstacao;
    novoDadosEstacao.push(data);
    setCreateEstacao(novoDadosEstacao);
    setModalCreateBombaPoco2(!modalCreateBombaPoco2);
    aoSalvarDados();
  };

  return (
    <ModalsBombaStyled>
      <form
        className="blocoBomba"
        onSubmit={handleSubmit(ArmazenaDadosBombaPoco2)}
      >
        <h3>Poço 2</h3>
        <span
          className="fechaModal"
          onClick={() => {
            setCreateEstacao([createEstacao[0]]);
            setModalCreateBombaPoco2(!modalCreateBombaPoco2);
            setModalCreatePoco(true);
          }}
        >
          <TbArrowBackUp />
        </span>

        <div className="divBomba1">
          <h3 className="tituloBombas">Cadastrar Bomba 1</h3>
          <div className="cadPoco">
            <div className="divSeletores">
              <div className="seletores">
                <label>Modelo de Bomba:</label>
                <select
                  {...register("tipo_bomba")}
                  onChange={(event) => handleSelectChange(event, 1)}
                >
                  <option value="" selected disabled hidden>
                    Seleciona um modelo
                  </option>
                  <option value={"helicoidal"}>Helicoidal</option>
                  <option value={"vertical"}>Deslocamento Vertival</option>
                </select>
                {errors.tipo_bomba && <p>{errors.tipo_bomba.message}</p>}
              </div>
              <div className="seletores">
                <label>Nível de Acionamento:</label>
                <input
                  placeholder="Nível de Acionamento"
                  type="number"
                  step="any"
                  {...register("nivel_acionamento")}
                ></input>
                {errors.nivel_acionamento && (
                  <p>{errors.nivel_acionamento.message}</p>
                )}
              </div>
              <div className="seletores">
                <label>Nível de Desligamento:</label>
                <input
                  placeholder="Nível de Desligamento"
                  type="number"
                  step="any"
                  {...register("nivel_desligamento")}
                ></input>
                {errors.nivel_desligamento && (
                  <p>{errors.nivel_desligamento.message}</p>
                )}
              </div>
            </div>
            <div className="divSeletores">
              <div className="imgBomba">
                <img src={imgBomba} alt="" />
              </div>
            </div>
          </div>
        </div>

        {createEstacao[1].quantidade_bombas2 >= 2 && (
          <div className="divBomba2">
            <h3>Cadastrar Bomba 2</h3>
            <div className="cadPoco">
              <div className="divSeletores">
                <div className="seletores">
                  <label>Modelo de Bomba:</label>
                  <select
                    {...register("tipo_bomba2")}
                    onChange={(event) => handleSelectChange(event, 2)}
                  >
                    <option value="" selected disabled hidden>
                      Seleciona um modelo
                    </option>
                    <option value={"helicoidal"}>Helicoidal</option>
                    <option value={"vertical"}>Deslocamento Vertival</option>
                  </select>
                  {errors.tipo_bomba2 && <p>{errors.tipo_bomba2.message}</p>}
                </div>
                <div className="seletores">
                  <label>Nível de Acionamento:</label>
                  <input
                    placeholder="Nível de Acionamento"
                    type="number"
                    step="any"
                    {...register("nivel_acionamento2")}
                  ></input>
                  {errors.nivel_acionamento2 && (
                    <p>{errors.nivel_acionamento2.message}</p>
                  )}
                </div>
                <div className="seletores">
                  <label>Nível de Desligamento:</label>
                  <input
                    placeholder="Nível de Desligamento"
                    type="number"
                    step="any"
                    {...register("nivel_desligamento2")}
                  ></input>
                  {errors.nivel_desligamento2 && (
                    <p>{errors.nivel_desligamento2.message}</p>
                  )}
                </div>
              </div>
              <div className="divSeletores">
                <div className="imgBomba">
                  <img src={imgBomba2} alt="" />
                </div>
              </div>
            </div>
          </div>
        )}

        {createEstacao[1].quantidade_bombas2 === 3 && (
          <div className="divBomba3">
            <h3>Cadastrar Bomba 3</h3>
            <div className="cadPoco">
              <div className="divSeletores">
                <div className="seletores">
                  <label>Modelo de Bomba:</label>
                  <select
                    {...register("tipo_bomba3")}
                    onChange={(event) => handleSelectChange(event, 3)}
                  >
                    <option value="" selected disabled hidden>
                      Seleciona um modelo
                    </option>
                    <option value={"helicoidal"}>Helicoidal</option>
                    <option value={"vertical"}>Deslocamento Vertival</option>
                  </select>
                  {errors.tipo_bomba3 && <p>{errors.tipo_bomba3.message}</p>}
                </div>
                <div className="seletores">
                  <label>Nível de Acionamento:</label>
                  <input
                    placeholder="Nível de Acionamento"
                    type="number"
                    step="any"
                    {...register("nivel_acionamento3")}
                  ></input>
                  {errors.nivel_acionamento3 && (
                    <p>{errors.nivel_acionamento3.message}</p>
                  )}
                </div>
                <div className="seletores">
                  <label>Nível de Desligamento:</label>
                  <input
                    placeholder="Nível de Desligamento"
                    type="number"
                    step="any"
                    {...register("nivel_desligamento3")}
                  ></input>
                  {errors.nivel_desligamento3 && (
                    <p>{errors.nivel_desligamento3.message}</p>
                  )}
                </div>
              </div>
              <div className="divSeletores">
                <div className="imgBomba">
                  <img src={imgBomba3} alt="" />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="botaoContinuar">
          <button type="submit">Continuar</button>
        </div>
      </form>
    </ModalsBombaStyled>
  );
};

export const ModalsUpdateEstacao = () => {
  const {
    modalUpdateEstacao,
    setModalUpdateEstacao,
    componenteEstacao,
    setComponenteEstacao,
  } = useContext(AdminContext);

  const [formEstacaoSujo, setFormEstacaoSujo] = useState(false);
  const [formPocoSujo, setFormPocoSujo] = useState(false);
  const [formBombaSujo, setFormBombaSujo] = useState(false);
  const [mostrarConfirmacao, setMostrarConfirmacao] = useState(false);
  const [abaDestino, setAbaDestino] = useState(null);

  const handleTrocarAba = (novaAba) => {
    if (componenteEstacao === novaAba) return;

    const abaAtual = componenteEstacao;
    const houveMudancas =
      (abaAtual === "Estacao" && formEstacaoSujo) ||
      (abaAtual === "Poco1" && formPocoSujo) ||
      (abaAtual === "BombasPoco1" && formBombaSujo);

    if (houveMudancas) {
      setMostrarConfirmacao(true);
      setAbaDestino(novaAba);
    } else {
      setComponenteEstacao(novaAba);
    }
  };

  return (
    <ModalUpdateEstacaoStyled>
      <div className="Editar">
        <div className="titulo">
          <h3>Editar</h3>
          <span
            className="fechaModal"
            onClick={() => {
              setModalUpdateEstacao(!modalUpdateEstacao);
              setComponenteEstacao("Estacao");
            }}
          >
            <IoClose />
          </span>
        </div>

        <div className="botoesEdit">
          <button
            onClick={() => handleTrocarAba("Estacao")}
            className={
              componenteEstacao === "Estacao" ? "botao btPoco" : "botao"
            }
          >
            Estação
          </button>

          <button
            className={componenteEstacao === "Poco1" ? "botao btPoco" : "botao"}
            onClick={() => handleTrocarAba("Poco1")}
          >
            Poço
          </button>

          <button
            className={
              componenteEstacao === "BombasPoco1" ? "botao btPoco" : "botao"
            }
            onClick={() => handleTrocarAba("BombasPoco1")}
          >
            Bomba
          </button>
        </div>

        <div className="divUpdate">
          {componenteEstacao === "Estacao" && (
            <ComponentUpdateEstacao onChangeFormSujo={setFormEstacaoSujo} />
          )}
          {componenteEstacao === "Poco1" && (
            <ComponentUpdatePoco1 onChangeFormSujo={setFormPocoSujo} />
          )}
          {componenteEstacao === "Poco2" && <ComponentUpdatePoco2 />}

          {componenteEstacao === "BombasPoco1" && (
            <ComponentUpdateBombasPoco1 onChangeFormSujo={setFormBombaSujo} />
          )}
        </div>
      </div>

      {mostrarConfirmacao && (
        <ConfirmaUpdate
          onConfirm={() => {
            // Aqui você pode chamar handleSubmit diretamente ou dar submit via JS (como está abaixo)
            document
              .querySelector("form")
              .dispatchEvent(
                new Event("submit", { bubbles: true, cancelable: true })
              );
            setComponenteEstacao(abaDestino);
            setMostrarConfirmacao(false);
          }}
          onCancel={() => {
            setComponenteEstacao(abaDestino);
            setMostrarConfirmacao(false);
          }}
        />
      )}
    </ModalUpdateEstacaoStyled>
  );
};

// export const ModalsUpdateBomba = () => {
//   const {
//     modalUpdateBomba,
//     setModalUpdateBomba,
//     setModalUpdatePoco,
//     setUpdateEstacao,
//     updateEstacao,
//     setModalUpdateBombaPoco2,
//     listarGeral,
//     aoEditarDados,
//   } = useContext(AdminContext);

//   const [imgBomba, setImgBomba] = useState(null);
//   const [imgBomba2, setImgBomba2] = useState(null);
//   const [imgBomba3, setImgBomba3] = useState(null);

//   const FormSchema = yup.object().shape({
//     tipo_bomba: yup.string().required("*Este campo é obrigatório"),
//     nivel_acionamento: yup
//       .number()
//       .nullable("*Este campo é obrigatório")
//       .typeError("*Este campo deve ser um número")
//       .required("*Este campo é obrigatório"),
//     nivel_desligamento: yup
//       .number()
//       .nullable("*Este campo é obrigatório")
//       .typeError("*Este campo deve ser um número")
//       .required("*Este campo é obrigatório"),

//     tipo_bomba2: yup.string().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas >= 2,
//       then: yup.string().required("*Este campo é obrigatório"),
//     }),

//     nivel_acionamento2: yup.number().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas >= 2,
//       then: yup
//         .number()
//         .nullable("*Este campo é obrigatório")
//         .typeError("*Este campo deve ser um número")
//         .required("*Este campo é obrigatório"),
//     }),

//     nivel_desligamento2: yup.number().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas >= 2,
//       then: yup
//         .number()
//         .nullable("*Este campo é obrigatório")
//         .typeError("*Este campo deve ser um número")
//         .required("*Este campo é obrigatório"),
//     }),

//     tipo_bomba3: yup.string().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas === 3,
//       then: yup.string().required("*Este campo é obrigatório"),
//     }),

//     nivel_acionamento3: yup.number().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas === 3,
//       then: yup
//         .number()
//         .nullable("*Este campo é obrigatório")
//         .typeError("*Este campo deve ser um número")
//         .required("*Este campo é obrigatório"),
//     }),

//     nivel_desligamento3: yup.number().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas === 3,
//       then: yup
//         .number()
//         .nullable("*Este campo é obrigatório")
//         .typeError("*Este campo deve ser um número")
//         .required("*Este campo é obrigatório"),
//     }),
//   });

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     resolver: yupResolver(FormSchema),
//   });

//   const ArmazenaDadosBomba = async (data) => {
//     if (updateEstacao[0].quantidadePocos === 1) {
//       let novoDadosEstacao = updateEstacao;
//       novoDadosEstacao.push(data);
//       setUpdateEstacao(novoDadosEstacao);
//       setModalUpdateBomba(!modalUpdateBomba);
//       aoEditarDados();
//     } else {
//       let novoDadosEstacao = updateEstacao;
//       novoDadosEstacao.push(data);
//       setUpdateEstacao(novoDadosEstacao);
//       setModalUpdateBomba(!modalUpdateBomba);
//       setModalUpdateBombaPoco2(true);
//     }
//   };

//   const pocoOrdenada = listarGeral.pocos_array.sort(
//     (a, b) => a.numero_poco - b.numero_poco
//   );

//   const pocoBombas = pocoOrdenada[0].bombas.sort(
//     (a, b) => a.numero_bomba - b.numero_bomba
//   );

//   useEffect(() => {
//     const pocoOrdenada = listarGeral.pocos_array.sort(
//       (a, b) => a.numero_poco - b.numero_poco
//     );

//     if (pocoOrdenada.length > 0 && pocoOrdenada[0].bombas.length > 0) {
//       const pocoBombas = pocoOrdenada[0].bombas.sort(
//         (a, b) => a.numero_bomba - b.numero_bomba
//       );

//       if (
//         pocoBombas[0].tipo_bomba &&
//         pocoBombas[0].tipo_bomba === "helicoidal"
//       ) {
//         setImgBomba(helicoidal);
//       } else {
//         setImgBomba(vertical);
//       }

//       if (pocoBombas.length > 1) {
//         if (
//           pocoBombas[1].tipo_bomba &&
//           pocoBombas[1].tipo_bomba === "helicoidal"
//         ) {
//           setImgBomba2(helicoidal);
//         } else {
//           setImgBomba2(vertical);
//         }
//         if (pocoBombas.length > 2) {
//           if (
//             pocoBombas[2].tipo_bomba &&
//             pocoBombas[2].tipo_bomba === "helicoidal"
//           ) {
//             setImgBomba3(helicoidal);
//           } else {
//             setImgBomba3(vertical);
//           }
//         }
//       }
//     }
//   }, [listarGeral]);

//   const handleSelectChange = (event, bomba) => {
//     const selectedOption = event.target.value;

//     if (bomba === 1) {
//       if (selectedOption === "helicoidal") {
//         setImgBomba(helicoidal);
//       } else if (selectedOption === "vertical") {
//         setImgBomba(vertical);
//       }
//     }
//     if (bomba === 2) {
//       if (selectedOption === "helicoidal") {
//         setImgBomba2(helicoidal);
//       } else if (selectedOption === "vertical") {
//         setImgBomba2(vertical);
//       }
//     }
//     if (bomba === 3) {
//       if (selectedOption === "helicoidal") {
//         setImgBomba3(helicoidal);
//       } else if (selectedOption === "vertical") {
//         setImgBomba3(vertical);
//       }
//     }
//   };

//   return (
//     <ModalsBombaStyled>
//       <form className="blocoBomba" onSubmit={handleSubmit(ArmazenaDadosBomba)}>
//         <h3>Poço 1</h3>
//         <span
//           className="fechaModal"
//           onClick={() => {
//             setUpdateEstacao([updateEstacao[0]]);
//             setModalUpdateBomba(!modalUpdateBomba);
//             setModalUpdatePoco(true);
//           }}
//         >
//           <TbArrowBackUp />
//         </span>

//         <div className="divBomba1">
//           <h3 className="tituloBombas">Cadastrar Bomba 1</h3>
//           <div className="cadPoco">
//             <div className="divSeletores">
//               <div className="seletores">
//                 <label>Modelo de Bomba:</label>
//                 <select
//                   defaultValue={
//                     pocoBombas[0].tipo_bomba && pocoBombas[0].tipo_bomba
//                   }
//                   {...register("tipo_bomba")}
//                   onChange={(event) => handleSelectChange(event, 1)}
//                 >
//                   <option value="" selected disabled hidden>
//                     Seleciona um modelo
//                   </option>
//                   <option value={"helicoidal"}>Helicoidal</option>
//                   <option value={"vertical"}>Deslocamento Vertival</option>
//                 </select>
//                 {errors.tipo_bomba && <p>{errors.tipo_bomba.message}</p>}
//               </div>
//               <div className="seletores">
//                 <label>Nível de Acionamento:</label>
//                 <input
//                   placeholder="Nível de Acionamento"
//                   type="number"
//                   step="any"
//                   defaultValue={pocoBombas[0].nivel_acionamento}
//                   {...register("nivel_acionamento")}
//                 ></input>
//                 {errors.nivel_acionamento && (
//                   <p>{errors.nivel_acionamento.message}</p>
//                 )}
//               </div>
//               <div className="seletores">
//                 <label>Nível de Desligamento:</label>
//                 <input
//                   placeholder="Nível de Desligamento"
//                   type="number"
//                   step="any"
//                   defaultValue={pocoBombas[0].nivel_desligamento}
//                   {...register("nivel_desligamento")}
//                 ></input>
//                 {errors.nivel_desligamento && (
//                   <p>{errors.nivel_desligamento.message}</p>
//                 )}
//               </div>
//             </div>
//             <div className="divSeletores">
//               <div className="imgBomba">
//                 <img src={imgBomba} alt="" />
//               </div>
//             </div>
//           </div>
//         </div>

//         {updateEstacao[1].quantidade_bombas >= 2 && (
//           <div className="divBomba2">
//             <h3>Cadastrar Bomba 2</h3>
//             <div className="cadPoco">
//               <div className="divSeletores">
//                 <div className="seletores">
//                   <label>Modelo de Bomba:</label>
//                   <select
//                     defaultValue={
//                       pocoBombas[1].tipo_bomba && pocoBombas[1].tipo_bomba
//                     }
//                     {...register("tipo_bomba2")}
//                     onChange={(event) => handleSelectChange(event, 2)}
//                   >
//                     <option value="" selected disabled hidden>
//                       Seleciona um modelo
//                     </option>
//                     <option value={"helicoidal"}>Helicoidal</option>
//                     <option value={"vertical"}>Deslocamento Vertival</option>
//                   </select>
//                   {errors.tipo_bomba2 && <p>{errors.tipo_bomba2.message}</p>}
//                 </div>
//                 <div className="seletores">
//                   <label>Nível de Acionamento:</label>
//                   <input
//                     placeholder="Nível de Acionamento"
//                     type="number"
//                     step="any"
//                     defaultValue={pocoBombas[1].nivel_acionamento}
//                     {...register("nivel_acionamento2")}
//                   ></input>
//                   {errors.nivel_acionamento2 && (
//                     <p>{errors.nivel_acionamento2.message}</p>
//                   )}
//                 </div>
//                 <div className="seletores">
//                   <label>Nível de Desligamento:</label>
//                   <input
//                     placeholder="Nível de Desligamento"
//                     type="number"
//                     step="any"
//                     defaultValue={pocoBombas[1].nivel_desligamento}
//                     {...register("nivel_desligamento2")}
//                   ></input>
//                   {errors.nivel_desligamento2 && (
//                     <p>{errors.nivel_desligamento2.message}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="divSeletores">
//                 <div className="imgBomba">
//                   <img src={imgBomba2} alt="" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {updateEstacao[1].quantidade_bombas === 3 && (
//           <div className="divBomba3">
//             <h3>Cadastrar Bomba 3</h3>
//             <div className="cadPoco">
//               <div className="divSeletores">
//                 <div className="seletores">
//                   <label>Modelo de Bomba:</label>
//                   <select
//                     defaultValue={
//                       pocoBombas[2].tipo_bomba && pocoBombas[2].tipo_bomba
//                     }
//                     {...register("tipo_bomba3")}
//                     onChange={(event) => handleSelectChange(event, 3)}
//                   >
//                     <option value="" selected disabled hidden>
//                       Seleciona um modelo
//                     </option>
//                     <option value={"helicoidal"}>Helicoidal</option>
//                     <option value={"vertical"}>Deslocamento Vertival</option>
//                   </select>
//                   {errors.tipo_bomba3 && <p>{errors.tipo_bomba3.message}</p>}
//                 </div>
//                 <div className="seletores">
//                   <label>Nível de Acionamento:</label>
//                   <input
//                     placeholder="Nível de Acionamento"
//                     type="number"
//                     step="any"
//                     defaultValue={pocoBombas[2].nivel_acionamento}
//                     {...register("nivel_acionamento3")}
//                   ></input>
//                   {errors.nivel_acionamento3 && (
//                     <p>{errors.nivel_acionamento3.message}</p>
//                   )}
//                 </div>
//                 <div className="seletores">
//                   <label>Nível de Desligamento:</label>
//                   <input
//                     placeholder="Nível de Desligamento"
//                     type="number"
//                     step="any"
//                     defaultValue={pocoBombas[2].nivel_desligamento}
//                     {...register("nivel_desligamento3")}
//                   ></input>
//                   {errors.nivel_desligamento3 && (
//                     <p>{errors.nivel_desligamento3.message}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="divSeletores">
//                 <div className="imgBomba">
//                   <img src={imgBomba3} alt="" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="botaoContinuar">
//           <button type="submit">Continuar</button>
//         </div>
//       </form>
//     </ModalsBombaStyled>
//   );
// };

// export const ModalsUpdateBombaPoco2 = () => {
//   const {
//     modalUpdateBomba,
//     setModalUpdateBomba,
//     setModalUpdatePoco,
//     setUpdateEstacao,
//     updateEstacao,
//     modalUpdateBombaPoco2,
//     setModalUpdateBombaPoco2,
//     listarGeral,
//     aoEditarDados,
//   } = useContext(AdminContext);

//   const [imgBomba, setImgBomba] = useState(null);
//   const [imgBomba2, setImgBomba2] = useState(null);
//   const [imgBomba3, setImgBomba3] = useState(null);

//   const handleSelectChange = (event, bomba) => {
//     const selectedOption = event.target.value;

//     if (bomba === 1) {
//       if (selectedOption === "helicoidal") {
//         setImgBomba(helicoidal);
//       } else if (selectedOption === "vertical") {
//         setImgBomba(vertical);
//       }
//     }
//     if (bomba === 2) {
//       if (selectedOption === "helicoidal") {
//         setImgBomba2(helicoidal);
//       } else if (selectedOption === "vertical") {
//         setImgBomba2(vertical);
//       }
//     }
//     if (bomba === 3) {
//       if (selectedOption === "helicoidal") {
//         setImgBomba3(helicoidal);
//       } else if (selectedOption === "vertical") {
//         setImgBomba3(vertical);
//       }
//     }
//   };

//   const FormSchema = yup.object().shape({
//     tipo_bomba: yup.string().required("*Este campo é obrigatório"),
//     nivel_acionamento: yup
//       .number()
//       .nullable("*Este campo é obrigatório")
//       .typeError("*Este campo deve ser um número")
//       .required("*Este campo é obrigatório"),
//     nivel_desligamento: yup
//       .number()
//       .nullable("*Este campo é obrigatório")
//       .typeError("*Este campo deve ser um número")
//       .required("*Este campo é obrigatório"),

//     tipo_bomba2: yup.string().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas >= 2,
//       then: yup.string().required("*Este campo é obrigatório"),
//     }),

//     nivel_acionamento2: yup.number().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas >= 2,
//       then: yup
//         .number()
//         .nullable("*Este campo é obrigatório")
//         .typeError("*Este campo deve ser um número")
//         .required("*Este campo é obrigatório"),
//     }),

//     nivel_desligamento2: yup.number().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas >= 2,
//       then: yup
//         .number()
//         .nullable("*Este campo é obrigatório")
//         .typeError("*Este campo deve ser um número")
//         .required("*Este campo é obrigatório"),
//     }),

//     tipo_bomba3: yup.string().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas === 3,
//       then: yup.string().required("*Este campo é obrigatório"),
//     }),

//     nivel_acionamento3: yup.number().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas === 3,
//       then: yup
//         .number()
//         .nullable("*Este campo é obrigatório")
//         .typeError("*Este campo deve ser um número")
//         .required("*Este campo é obrigatório"),
//     }),

//     nivel_desligamento3: yup.number().when("createEstacao", {
//       is: (val) => val && val[1] && val[1].quantidade_bombas === 3,
//       then: yup
//         .number()
//         .nullable("*Este campo é obrigatório")
//         .typeError("*Este campo deve ser um número")
//         .required("*Este campo é obrigatório"),
//     }),
//   });

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     resolver: yupResolver(FormSchema),
//   });

//   const ArmazenaDadosBomba = async (data) => {
//     if (updateEstacao[0].quantidadePocos === 1) {
//       let novoDadosEstacao = updateEstacao;
//       novoDadosEstacao.push(data);
//       setUpdateEstacao(novoDadosEstacao);
//       setModalUpdateBomba(!modalUpdateBomba);
//       aoEditarDados();
//     } else {
//       let novoDadosEstacao = updateEstacao;
//       novoDadosEstacao.push(data);
//       setUpdateEstacao(novoDadosEstacao);
//       setModalUpdateBomba(!modalUpdateBomba);
//       setModalUpdateBombaPoco2(true);
//     }
//   };

//   const pocoOrdenada = listarGeral.pocos_array.sort(
//     (a, b) => a.numero_poco - b.numero_poco
//   );

//   const pocoBombas = pocoOrdenada[1].bombas.sort(
//     (a, b) => a.numero_bomba - b.numero_bomba
//   );

//   useEffect(() => {
//     const pocoOrdenada = listarGeral.pocos_array.sort(
//       (a, b) => a.numero_poco - b.numero_poco
//     );

//     if (pocoOrdenada.length > 0 && pocoOrdenada[1].bombas.length > 0) {
//       const pocoBombas = pocoOrdenada[1].bombas.sort(
//         (a, b) => a.numero_bomba - b.numero_bomba
//       );

//       if (
//         pocoBombas[0].tipo_bomba &&
//         pocoBombas[0].tipo_bomba === "helicoidal"
//       ) {
//         setImgBomba(helicoidal);
//       } else {
//         setImgBomba(vertical);
//       }

//       if (pocoBombas.length > 1) {
//         if (
//           pocoBombas[1].tipo_bomba &&
//           pocoBombas[1].tipo_bomba === "helicoidal"
//         ) {
//           setImgBomba2(helicoidal);
//         } else {
//           setImgBomba2(vertical);
//         }
//         if (pocoBombas.length > 2) {
//           if (
//             pocoBombas[2].tipo_bomba &&
//             pocoBombas[2].tipo_bomba === "helicoidal"
//           ) {
//             setImgBomba3(helicoidal);
//           } else {
//             setImgBomba3(vertical);
//           }
//         }
//       }
//     }
//   }, [listarGeral]);

//   return (
//     <ModalsBombaStyled>
//       <form className="blocoBomba" onSubmit={handleSubmit(ArmazenaDadosBomba)}>
//         <h3>Poço 2</h3>
//         <span
//           className="fechaModal"
//           onClick={() => {
//             setUpdateEstacao([updateEstacao[0]]);
//             setModalUpdateBombaPoco2(!modalUpdateBombaPoco2);
//             setModalUpdatePoco(true);
//           }}
//         >
//           <TbArrowBackUp />
//         </span>

//         <div className="divBomba1">
//           <h3 className="tituloBombas">Cadastrar Bomba 1</h3>
//           <div className="cadPoco">
//             <div className="divSeletores">
//               <div className="seletores">
//                 <label>Modelo de Bomba:</label>
//                 <select
//                   defaultValue={
//                     pocoBombas[0].tipo_bomba && pocoBombas[0].tipo_bomba
//                   }
//                   {...register("tipo_bomba")}
//                   onChange={(event) => handleSelectChange(event, 1)}
//                 >
//                   <option value="" selected disabled hidden>
//                     Seleciona um modelo
//                   </option>
//                   <option value={"helicoidal"}>Helicoidal</option>
//                   <option value={"vertical"}>Deslocamento Vertival</option>
//                 </select>
//                 {errors.tipo_bomba && <p>{errors.tipo_bomba.message}</p>}
//               </div>
//               <div className="seletores">
//                 <label>Nível de Acionamento:</label>
//                 <input
//                   placeholder="Nível de Acionamento"
//                   type="number"
//                   step="any"
//                   defaultValue={pocoBombas[0].nivel_acionamento}
//                   {...register("nivel_acionamento")}
//                 ></input>
//                 {errors.nivel_acionamento && (
//                   <p>{errors.nivel_acionamento.message}</p>
//                 )}
//               </div>
//               <div className="seletores">
//                 <label>Nível de Desligamento:</label>
//                 <input
//                   placeholder="Nível de Desligamento"
//                   type="number"
//                   step="any"
//                   defaultValue={pocoBombas[0].nivel_desligamento}
//                   {...register("nivel_desligamento")}
//                 ></input>
//                 {errors.nivel_desligamento && (
//                   <p>{errors.nivel_desligamento.message}</p>
//                 )}
//               </div>
//             </div>
//             <div className="divSeletores">
//               <div className="imgBomba">
//                 <img src={imgBomba} alt="" />
//               </div>
//             </div>
//           </div>
//         </div>

//         {updateEstacao[1].quantidade_bombas2 >= 2 && (
//           <div className="divBomba2">
//             <h3>Cadastrar Bomba 2</h3>
//             <div className="cadPoco">
//               <div className="divSeletores">
//                 <div className="seletores">
//                   <label>Modelo de Bomba:</label>
//                   <select
//                     defaultValue={
//                       pocoBombas[1].tipo_bomba && pocoBombas[1].tipo_bomba
//                     }
//                     {...register("tipo_bomba2")}
//                     onChange={(event) => handleSelectChange(event, 2)}
//                   >
//                     <option value="" selected disabled hidden>
//                       Seleciona um modelo
//                     </option>
//                     <option value={"helicoidal"}>Helicoidal</option>
//                     <option value={"vertical"}>Deslocamento Vertival</option>
//                   </select>
//                   {errors.tipo_bomba2 && <p>{errors.tipo_bomba2.message}</p>}
//                 </div>
//                 <div className="seletores">
//                   <label>Nível de Acionamento:</label>
//                   <input
//                     placeholder="Nível de Acionamento"
//                     type="number"
//                     step="any"
//                     defaultValue={pocoBombas[1].nivel_acionamento}
//                     {...register("nivel_acionamento2")}
//                   ></input>
//                   {errors.nivel_acionamento2 && (
//                     <p>{errors.nivel_acionamento2.message}</p>
//                   )}
//                 </div>
//                 <div className="seletores">
//                   <label>Nível de Desligamento:</label>
//                   <input
//                     placeholder="Nível de Desligamento"
//                     type="number"
//                     step="any"
//                     defaultValue={pocoBombas[1].nivel_desligamento}
//                     {...register("nivel_desligamento2")}
//                   ></input>
//                   {errors.nivel_desligamento2 && (
//                     <p>{errors.nivel_desligamento2.message}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="divSeletores">
//                 <div className="imgBomba">
//                   <img src={imgBomba2} alt="" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {updateEstacao[1].quantidade_bombas2 === 3 && (
//           <div className="divBomba3">
//             <h3>Cadastrar Bomba 3</h3>
//             <div className="cadPoco">
//               <div className="divSeletores">
//                 <div className="seletores">
//                   <label>Modelo de Bomba:</label>
//                   <select
//                     defaultValue={
//                       pocoBombas[2].tipo_bomba && pocoBombas[2].tipo_bomba
//                     }
//                     {...register("tipo_bomba3")}
//                     onChange={(event) => handleSelectChange(event, 3)}
//                   >
//                     <option value="" selected disabled hidden>
//                       Seleciona um modelo
//                     </option>
//                     <option value={"helicoidal"}>Helicoidal</option>
//                     <option value={"vertical"}>Deslocamento Vertival</option>
//                   </select>
//                   {errors.tipo_bomba3 && <p>{errors.tipo_bomba3.message}</p>}
//                 </div>
//                 <div className="seletores">
//                   <label>Nível de Acionamento:</label>
//                   <input
//                     placeholder="Nível de Acionamento"
//                     type="number"
//                     step="any"
//                     defaultValue={pocoBombas[2].nivel_acionamento}
//                     {...register("nivel_acionamento3")}
//                   ></input>
//                   {errors.nivel_acionamento3 && (
//                     <p>{errors.nivel_acionamento3.message}</p>
//                   )}
//                 </div>
//                 <div className="seletores">
//                   <label>Nível de Desligamento:</label>
//                   <input
//                     placeholder="Nível de Desligamento"
//                     type="number"
//                     step="any"
//                     defaultValue={pocoBombas[2].nivel_desligamento}
//                     {...register("nivel_desligamento3")}
//                   ></input>
//                   {errors.nivel_desligamento3 && (
//                     <p>{errors.nivel_desligamento3.message}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="divSeletores">
//                 <div className="imgBomba">
//                   <img src={imgBomba3} alt="" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="botaoContinuar">
//           <button type="submit">Continuar</button>
//         </div>
//       </form>
//     </ModalsBombaStyled>
//   );
// };

export const ModalsDesableEstacao = () => {
  const {
    modalsDesableEstacao,
    setDesableEstacao,
    selecionaEstacoes,
    aoDesabilitarEstacao,
  } = useContext(AdminContext);

  return (
    <ModalsConfirmeStyled>
      <div className="blocoConfirma">
        <h3>Tem certeza que deseja executar esta ação?</h3>
        <div className="botao">
          <button onClick={() => aoDesabilitarEstacao()}>Sim</button>
          <button
            className="botaoNao"
            onClick={() => setDesableEstacao(!modalsDesableEstacao)}
          >
            Não
          </button>
        </div>
      </div>
    </ModalsConfirmeStyled>
  );
};

export const ModalResetGtw = ({ gtwId }) => {
  const { exibirErro, headerApi, setModalResetGtwOn } =
    useContext(AdminContext);

  const resetGtw = async () => {
    try {
      await apiSae.post(`/users/reset-gateway/${gtwId}`, {}, headerApi);
      toast.success("Connect Reniciado!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } catch (error) {
      exibirErro("Erro ao resetar o Gateway");
    }
  };

  return (
    <ModalsConfirmeStyled>
      <div className="blocoConfirma">
        <h3>Tem certeza que deseja Reniciar o Connect</h3>
        <div className="botao">
          <button
            onClick={() => {
              resetGtw();
              setModalResetGtwOn(false);
            }}
          >
            Sim
          </button>
          <button
            className="botaoNao"
            onClick={() => {
              setModalResetGtwOn(false);
            }}
          >
            Não
          </button>
        </div>
      </div>
    </ModalsConfirmeStyled>
  );
};

export const ModalEditarSenha = () => {
  const { modalEditarSenha, setModalEditarSenha, infoUser, headerApi } =
    useContext(HomeContext);

  const aoEditarSenhaUsuario = async (dados) => {
    const tratativa = { usuario: dados.usuario, password: dados.password };

    try {
      await apiSae.patch(`/users/${infoUser.id}`, tratativa, headerApi);

      setModalEditarSenha(!modalEditarSenha);

      toast.success("Senha Editada com sucesso!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } catch (error) {
      console.log(error);
    }
  };

  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [mostrarConfirmaSenha, setMostrarConfirmaSenha] = useState(false);

  const isRestrictedUser = infoUser.role === "1" || infoUser.role === "2";

  const FormSchema = yup.object().shape({
    usuario: yup.string(),
    nome: yup.string(),
    email: yup.string().email("*E-mail inválido"),
    matricula: yup.string(),

    password: yup
      .string()
      .test({
        name: "requiredIfFilled",
        test: function (value) {
          if (!value || value.length === 0) {
            return true;
          } else {
            return (
              value.length >= 8 &&
              /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+])[a-zA-Z0-9!@#$%^&*()_+]+$/.test(
                value
              )
            );
          }
        },
        message: "Mín. 8 Carac. sendo 1 Letra Maiúscula e 1 Carac. especial",
      })
      .required("*Este campo é obrigatório"),

    confirmaSenha: yup
      .string()
      .oneOf([yup.ref("password"), null], "As senhas devem ser iguais")
      .required("*Este campo é obrigatório"),

    role: yup.string(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues: {
      usuario: infoUser.usuario,
      nome: infoUser.nome,
      email: infoUser.email,
      matricula: infoUser.matricula,
      password: "",
      confirmaSenha: "",
    },
  });

  return (
    <ModalsStyled>
      <form
        className="blocoUsuario"
        onSubmit={handleSubmit(aoEditarSenhaUsuario)}
      >
        <h3>Editar Senha de Usuários</h3>
        <span
          className="fechaModal"
          onClick={() => setModalEditarSenha(!modalEditarSenha)}
        >
          <IoClose />
        </span>
        <div className="inpults">
          <label>Usuário:</label>
          <span>
            <AiOutlineUserAdd />
          </span>
          <input
            className="updateUsuario"
            placeholder="Digite o Usúario"
            type="text"
            // defaultValue={infoUser.usuario}
            {...register("usuario")}
            disabled={isRestrictedUser}
          />
          {errors.usuario && <p>{errors.usuario.message}</p>}
        </div>
        <div className="inpults">
          <label>Nome Completo:</label>
          <span>
            <MdOutlineDriveFileRenameOutline />
          </span>
          <input
            className="updateUsuario"
            placeholder="Digite o Nome Completo"
            type="text"
            // defaultValue={infoUser.nome}
            {...register("nome")}
            disabled={isRestrictedUser}
          />
          {errors.nome && <p>{errors.nome.message}</p>}
        </div>
        <div className="inpults">
          <label>Email:</label>
          <span>
            <MdOutlineEmail />
          </span>
          <input
            className="updateUsuario"
            placeholder="Digite o email"
            type="email"
            // defaultValue={infoUser.email}
            {...register("email")}
            disabled={isRestrictedUser}
          />
          {errors.email && <p>{errors.email.message}</p>}
        </div>
        <div className="inpults">
          <label>Matricula:</label>
          <span>
            <MdOutlineAppRegistration />
          </span>
          <input
            className="updateUsuario"
            placeholder="Digite a matricula"
            type="text"
            // defaultValue={infoUser.matricula}
            {...register("matricula")}
            disabled={isRestrictedUser}
          />
          {errors.matricula && <p>{errors.matricula.message}</p>}
        </div>
        <div className="divSenha inpults">
          <div className="campoSenha">
            <label>Senha:</label>
            <span>
              <RiLockPasswordLine />
            </span>
            <div className="inputSenha">
              <input
                placeholder="Digite a Senha"
                // type="password"
                type={mostrarSenha ? "text" : "password"}
                {...register("password")}
              />
              <button
                type="button"
                className="toggleSenha"
                onClick={() => setMostrarSenha(!mostrarSenha)}
              >
                {mostrarSenha ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
            {errors.hash_senha && <p>{errors.hash_senha.message}</p>}
          </div>
          <div className="campoSenha">
            <label>Confirmar Senha:</label>
            <span>
              <RiLockPasswordLine />
            </span>
            <div className="inputSenha">
              <input
                placeholder="Confirme a Senha"
                type={mostrarSenha ? "text" : "password"}
                {...register("confirmaSenha")}
              />
              <button
                type="button"
                className="toggleSenha"
                onClick={() => setMostrarSenha(!mostrarSenha)}
              >
                {mostrarSenha ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>

            {errors.confirmaSenha && <p>{errors.confirmaSenha.message}</p>}
          </div>
        </div>

        <div className="botao">
          <button type="submit">Salvar</button>
        </div>
      </form>
    </ModalsStyled>
  );
};
